const Project = ({ item }) => {
  return (
    <div className="bg-secondary p-8 rounded-2xl">
      <div className="mb-6">
        <h3 className="text-2xl font-semibold mb-3">{item.name}</h3>

        <p className="text-accent text-sm uppercase tracking-wider">
          {item.stack}
        </p>
      </div>

      <div className="space-y-4 text-paragraph leading-relaxed">
        <p>
          <strong>Problema:</strong> {item.problem}
        </p>

        <p>
          <strong>Enfoque:</strong> {item.approach}
        </p>

        <p>
          <strong>Resultado:</strong> {item.result}
        </p>
      </div>

      {item.href && (
        <div className="mt-6">
          <a
            href={item.href}
            target="_blank"
            rel="noreferrer"
            className="text-accent hover:underline"
          >
            Ver repositorio →
          </a>
        </div>
      )}
    </div>
  );
};

export default Project;
